export default "__VITE_ASSET__DiIkBXQI__"